export default __webpack_public_path__ + "static/media/heroplus-bg3-ad8ec66b321a6b33ec0f80c701d52d3d.png";